module.exports = __webpack_public_path__ + "static/media/FUN88_Afiliate_Page_QRline1.229f9834.jpg";